import { Col, Modal, Row, Tag, Tooltip, Typography } from "antd";
import { FC, useState } from "react";
import CardItemCarouselIndex from "./CardItemCarouselIndex";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import {
  EyeFilled,
  HeartFilled,
  MessageFilled,
} from "@ant-design/icons";
import { handleFindOption } from "helpers/findOptionInfoes";
import dayjs from "dayjs";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { Link, useNavigate } from "react-router-dom";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import PriceFormatter from "apps/Common/PriceFormatter";
import PortfolioListViewOptions from "./PortfolioListViewOptions";
import CreateContactInfoes from "../Details/Components/CreateContactInfoes";
import SharedAdvert from "../Details/Components/Options/Components/SharedAdvert";
import AdvertOptions from "./AdvertOptions";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import TruncatedText from "apps/Common/TruncatedText";
import { handleSetColorTitleStatus } from "apps/Common/SetColorTitleStatus";
import WrapperBadge from "./WrapperBadge";
import framephone from "../../../assets/Images/Frame-Phone.png";
import frameshare from "../../../assets/Images/Frame-Share.png";
import { slugify } from "../../utils/slugify";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { getAdvertListFilter } from "../../News/Services";
import { handleSetAdvertListFilter } from "../ListItems/ClientStates";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
interface RealStateListViewItemProps {
  item: any;
  advertType?: string;
  pageType?: string;
  data?: any;
  setData?: any;
}

const RealStateListViewItem: FC<RealStateListViewItemProps> = (props) => {
  const dispatch = useDispatch()
  const locations = useLocation();
  // const [searchParams] = useSearchParams();
  //   // URL'den parametreleri al
  // const categoryId = searchParams.get('CategoryId');
  // const cityId = searchParams.get('CityId');
  // const districtIds = searchParams.get('DistrictIds');
  // const neighbourhoodIds = searchParams.get('NeighbourhoodIds');
  // console.log('cityId:', cityId);
  // // API'ye göndermek için filtre objesi oluştur
  // const filterParams = {
  //   CategoryId: categoryId ? Number(categoryId) : undefined,
  //   CityId: cityId ? Number(cityId) : undefined,
  //   DistrictIds: districtIds ? [Number(districtIds)] : undefined,
  //   NeighbourhoodIds: neighbourhoodIds ? [Number(neighbourhoodIds)] : undefined
  // };

  // Bu filtreleri kullanarak ilan listesini getir
  // useEffect(() => {
  //   const handleFilterAndFetch = async () => {
  //     let finalFilterParams = { ...filterParams };

  //     // locations.state varsa önce onu işle
  //     if (locations.state) {
  //       const { appliedFilters } = locations.state;

  //       const updatedFilter = {
  //         ...appliedFilters,
  //         PageIndex: 1,
  //         PageSize: 20,
  //         CategoryId: appliedFilters.CategoryId,
  //         CityId: appliedFilters.CityId,
  //         DistrictIds: appliedFilters.DistrictIds,
  //         NeighbourhoodIds: appliedFilters.NeighbourhoodIds
  //       };

  //       dispatch(handleSetAdvertListFilter({ filter: updatedFilter }));
  //       finalFilterParams = updatedFilter;
  //     }

  //     // API çağrısını yap
  //     try {
  //       const response = await getAdvertListFilter(finalFilterParams);
  //       if (response?.success) {
  //         // response.data'yı işle
  //       }
  //     } catch (error) {
  //       console.error('Filter error:', error);
  //     }
  //   };

  //   handleFilterAndFetch();
  // }, [searchParams, locations.state, dispatch]);


  const { Text } = Typography;
  const navigate = useNavigate()
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const fullPath = `${props.item?.neighbourhood?.name || ""} ${props.item?.district?.name || ""
    } ${props.item?.city?.name || ""}`;
  const location = `${props.item?.city?.name || ""}`;
  const [isShowCreateContactModal, setIsShowCreateContactModal] =
    useState(false);
  const [isShowSharedAdvertModal, setIsShowSharedAdvertModal] = useState(false);

  const { capitalize } = useCapitalize();
  const isBoldFontColored = props.item?.dopingList?.find((item: any) =>
    item?.id === 10
  );

  const formatValue = (key: string, value: any) => {
    const normalizedValue = String(value).trim().toLowerCase();

    if (["evet", "hayır", "hayir"].includes(normalizedValue)) {
      return key;
    }

    if (key.toLowerCase().includes("km") && !normalizedValue.includes("km")) {
      return ` ${value} Km`;
    }

    if (key.includes("m²") && !String(value).includes("m²")) {
      return `${key.match(/\((.*?)\)/)?.[1]} ${value} m²`;
    }

    return key + " : " + value;
  };
  //  const parsedOptions1 = JSON.parse(props?.item?.cardViewAdvertOptions);
  //  console.log(parsedOptions1)

  return (
    <>
      <Row
        gutter={[20, 0]}
        style={{ marginLeft: 0, marginRight: 0 }}
        className={`${isBoldFontColored ? "!bg-blue-50" : ""}`}
      >
        <Col xs={9} md={6} xl={4} className="!pl-[5px] !pr-0">
          <Link to={`/${slugify(props?.item?.title || 'ilan')}/detay?id=${props?.item.id}`} className="!w-full !h-full">
            <WrapperBadge item={props.item}>
              <CardItemCarouselIndex
                item={props.item}
                viewType="list"
                pageType={props.pageType}
                data={props.data}
                setData={props.setData}
              />
            </WrapperBadge>
          </Link>
        </Col>
        <Col xs={15} md={18} xl={20}   >
          <Row className="!flex !w-full items-center !h-full">
            <Col xs={24}>
              <Link
                to={`/${slugify(props?.item?.title || 'ilan')}/detay?id=${props?.item.id}`}
                className="!w-full !h-full"
              >
                <Row>
                  <Col xs={24} md={10}>
                    <Row gutter={[20, 0]}>
                      <Col xs={24} className="!flex justify-between items-center md:!block ">
                        <Tooltip title={"İlan No"}>
                          {props.item.no}
                          {/* <TruncatedText
                          wrapperClassName="!flex items-center"
                          textClassName={`!text-[12px] sm:!text-[14px] lg:!text-[16px] !text-gray-500 ${isBoldFontColored ? "!font-bold" : ""} `}
                          maxLines={1}
                          title={props.item.no}
                        /> */}
                        </Tooltip>

                        {
                          props.pageType === "portfolio" &&
                          <span className="!inline lg:!hidden " >
                            <Tag
                              className="!text-[8px] md:!text-sm"
                              color={handleSetColorTitleStatus(
                                "color",
                                props.item.status
                              )}
                            >
                              {handleSetColorTitleStatus(
                                "title",
                                props.item.status
                              )}
                            </Tag>
                          </span>
                        }
                      </Col>
                      <Col xs={24} lg={24}>
                        <Row gutter={[0, 5]}>
                          {props.pageType === "portfolio" && (
                            <>
                              <Col xs={24}>
                                <div className="!flex gap-4">
                                  <div className="!flex items-center gap-1">
                                    <MessageFilled
                                      className={`!text-gray-500`}
                                    />
                                    <Text className={`"!text-black`}>
                                      {props.item?.messageCount || 0}
                                    </Text>
                                  </div>
                                  <div className="!flex items-center gap-1">
                                    <EyeFilled
                                      className={`!text-gray-400 !text-lg`}
                                    />
                                    <Text className={`!text-black `}>
                                      {props.item?.viewCount || 0}
                                    </Text>
                                  </div>
                                  <div className="!flex items-center gap-1">
                                    <HeartFilled className="!text-red-500 " />
                                    <Text className={`!text-black`}>
                                      {props.item?.favoriteCount || 0}
                                    </Text>
                                  </div>
                                </div>
                              </Col>
                            </>
                          )}
                          <Col xs={24}>
                            <TruncatedText
                              wrapperClassName="!flex items-center"
                              textClassName={`!text-[12px] sm:!text-[14px] lg:!text-[16px] !text-[#488af6]  !flex items-center ${isBoldFontColored ? "!font-bold" : ""
                                } `}
                              maxLines={1}
                              title={capitalize(props.item.title)}
                            />
                          </Col>
                          <Col
                            xs={24}
                            className="!flex !flex-col items-start xl:!flex-row xl:items-center gap-2 "
                          >
                            <Text className="!font-bold !text-[20px] !text-[#3b4144] ">
                              <PriceFormatter
                                inputPrice={props.item.price}
                                currency={props.item?.currency?.shortName}
                              />
                            </Text>
                            {props.pageType === "portfolio" &&
                              props.item?.expiryDate && (
                                <Tag
                                  color="#ffc600"
                                  className={`!m-0 !text-black`}
                                >
                                  <div className="!flex ">
                                    <span>
                                      {" "}
                                      {`Geçerlilik Tarihi: ${dayjs(
                                        props.item?.expiryDate
                                      ).format("DD.MM.YYYY")}`}
                                    </span>
                                  </div>
                                </Tag>
                              )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} md={14} className="">
                    <Row gutter={[5, 0]}>
                      <Col xs={24} lg={10} className="!flex !flex-col !items-start !gap-1">
                        {props?.item?.cardViewAdvertOptions && (
                          <div className="flex flex-row sm:flex-col items-start gap-1">
                            {(() => {
                              try {
                                const parsedOptions = JSON.parse(props?.item?.cardViewAdvertOptions);

                                const priorityKeys = props.item.type === 0
                                  ? ["m² (Brüt)", "m² (Net)", "Kat Sayısı", "Bulunduğu Kat", "Oda Sayısı"]
                                  : ["Yıl", "KM", "Renk"];

                                const selectedValues = [];

                                // Öncelikli anahtarları işle
                                for (const key of priorityKeys) {
                                  if (parsedOptions[key] && selectedValues.length < 3) {
                                    selectedValues.push({ key, value: parsedOptions[key] });

                                  }
                                }

                                // // Diğer anahtarları işle
                                if (selectedValues.length < 3) {
                                  for (const [key, value] of Object.entries(parsedOptions)) {
                                    console.log("parsedOptions", parsedOptions);
                                    if (
                                      !priorityKeys.includes(key) &&
                                      key.toLowerCase() !== "plate" &&
                                      selectedValues.length < 3
                                    ) {
                                      selectedValues.push({ key, value });
                                    }
                                  }
                                }

                                return selectedValues.map((item, index) => (
                                  <Tag
                                    key={index}
                                    className="!bg-[#dce8ff] !text-black !m-0 !text-[10px] md:!text-xs"
                                    style={{ color: "#000" }}
                                  >
                                    <Tooltip title={item.key}>
                                      <span className={isBoldFontColored ? "!font-bold" : ""}>
                                        {formatValue(item.key, item.value)}
                                      </span>
                                    </Tooltip>
                                  </Tag>
                                ));

                              } catch (e) {
                                return null;
                              }
                            })()}
                            {/* <AdvertOptions
                                                                  options={props.item.cardViewAdvertOptions}
                                                                  type={props.item.type}
                                                                  isBoldFontColored={isBoldFontColored}
                                                                /> */}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} lg={6} className="">
                        <Row>
                          <Col xs={24} className=" ">
                            <TruncatedText
                              wrapperClassName="!flex"
                              textClassName={`!text-[#3b4144] !text-xs sm:!text-sm  ${isBoldFontColored ? "!font-bold" : ""
                                } `}
                              maxLines={1}
                              title={location}
                            />
                          </Col>
                          <Col xs={24}>
                            <TruncatedText
                              wrapperClassName=""
                              textClassName={`!text-xs !text-gray-400 ${isBoldFontColored ? "!font-bold" : ""
                                }`}
                              maxLines={1}
                              title={fullPath}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} lg={8} className="!flex items-center justify-end">
                        <Row>
                          <Col xs={24} className="">
                            <Text
                              className={`!text-gray-400 !text-xs sm:!text-sm  ${isBoldFontColored ? "!font-bold" : ""
                                }`}
                            >
                              {props.item.advertOptionAttr
                                ? handleFindOption(
                                  "Kimden",
                                  props.item.advertOptionAttr
                                )
                                : ""}
                            </Text>
                          </Col>
                          <Col xs={24} className=" ">
                            {
                              <Text
                                className={`!text-[#000] !text-xs sm:!text-sm  ${isBoldFontColored ? "!font-bold" : ""
                                  }`}
                              >
                                <Tag
                                  className="!bg-[#dce8ff] hidden sm:block"
                                  color="primary"
                                  style={{ color: "#000" }}
                                >
                                  {dayjs(props.item.insertDate).format(
                                    "DD.MM.YYYY"
                                  )}
                                </Tag>
                              </Text>
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Link>
            </Col>
            <Col xs={24}>
              <Row gutter={[0, 20]}>
                <Col
                  xs={24}
                  lg={12}
                  className={`!grid gap-2  md:items-center md:gap-4`}
                >
                  <div className="items-center gap-1 !hidden lg:!flex  ">
                    {props.item?.store?.photoUrl && (
                      <LazyLoadImage
                        wrapperWidth="30px"
                        wrapperHeight="30px"
                        src={setBackEndUlr() + "/" + props.item.store.photoUrl}
                        alt=""
                        imageClassName="!rounded-md"
                      />
                    )}
                    <div className="!hidden lg:!block" >
                      {props?.item.store?.storeName && (
                        <>
                          <div className="">
                            <Text
                              className={`!text-black !text-[10px] sm:!text-sm ${isBoldFontColored ? "!font-bold  " : ""
                                }`}
                            >
                              {props?.item.store?.storeName}
                            </Text>
                          </div>
                        </>
                      )}
                      <div>
                        <Text
                          className={`!text-gray-400 !text-[10px] sm:!text-xs ${isBoldFontColored ? "!font-bold" : ""}`}
                        >
                          {`${props.item?.user?.name || ""} ${props.item?.user?.surname || ""
                            }`}
                        </Text>
                      </div>
                    </div>
                  </div>
                  <div className="!flex gap-3  justify-between  ">
                    <div className="!flex gap-3" >
                      {/* Butonlar burada kaldırıldı */}
                    </div>
                    <div className="!block lg:!hidden" >
                      {props.pageType === "portfolio" && (
                        <PortfolioListViewOptions item={props.item} />
                      )}
                    </div>
                  </div>
                </Col>
                <Col
                  xs={24}
                  lg={12}
                  className=" justify-end items-center gap-1 pr-3 !hidden lg:!flex"
                >
                  {userInfoes?.id !== props.item?.userId ? (
                    <Tooltip title={"İletişim Kur"}>
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setIsShowCreateContactModal(true);
                        }}
                        className="hover:cursor-pointer !flex gap-1 md:!py-2 md:px-4 !p-1 !rounded-md   transition items-center"
                      >
                        <img src={framephone} style={{ maxWidth: '20px' }} alt="" />
                      </span>
                    </Tooltip>

                  ) : null}
                  <Tooltip title={"İlanı Paylaş"}>
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsShowSharedAdvertModal(true);
                      }}
                      className={`hover:cursor-pointer !flex gap-1 md:!py-2 md:px-4  !p-2  !rounded-md transition items-center !max-h-[33px]`}
                    >
                      <img src={frameshare} alt="" style={{ maxWidth: '20px' }} />
                    </span>
                  </Tooltip>

                  {props.pageType === "portfolio" && (
                    <PortfolioListViewOptions item={props.item} />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Modal
        title={false}
        onCancel={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsShowCreateContactModal(false);
        }}
        open={isShowCreateContactModal}
        footer={false}
      >
        <CreateContactInfoes externalAdvert={props?.item} />
      </Modal>
      <Modal
        open={isShowSharedAdvertModal}
        onCancel={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsShowSharedAdvertModal(false);
        }}
        footer={false}
        title={"İlanı Paylaş"}
      >
        <SharedAdvert advert={props.item} />
      </Modal>
    </>
  );
};

export default RealStateListViewItem;